import * as Types from '../generated/types';

import { gql } from '@apollo/client';
export type DealNodeFragment = { __typename?: 'DealNode', id: string, currency: Types.DealsDealCurrencyChoices, creationTime?: any | null, updateTime?: any | null, modelYear?: number | null, freeKmPerYear?: number | null, monthlyPayment?: number | null, fullMonthlyPrice?: number | null, deposit?: number | null, carPrice?: number | null, servicePrice?: number | null, totalPrice?: number | null, baseIndex?: number | null, participationFee?: number | null, residualPrice?: number | null, comprehensiveInsurancePrice?: number | null, comprehensiveInsuranceYoungPrice?: number | null, compulsoryInsurancePrice?: number | null, licenceAndInsurancePricePerMonth?: number | null, licencePrice?: number | null, leaseDuration: number, dealTypeString?: string | null, notes?: string | null, isOperational: boolean, status?: Types.DealsDealStatusChoices | null, startDate: any, endDate: any, signDate?: any | null, proposalNumberRef?: string | null, trackingMonthlyRate?: number | null, npv?: number | null, agent?: { __typename?: 'MeNode', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, car?: { __typename?: 'CarNode', id: string, number: string, color?: string | null, carSubModel: { __typename?: 'CarSubModelNode', name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', name: string, localName?: string | null } } } | null, carSubModel?: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } } } | null, proposal?: { __typename?: 'ProposalNode', id: string, currency: Types.DealsProposalCurrencyChoices, leaseDuration: number, isOperational: boolean, isLocked: boolean } | null, customer?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, type: Types.CustomersCustomerTypeChoices, title?: Types.CustomersCustomerTitleChoices | null, shouldUnionInvoices: boolean } | null };

export const DealNodeFragmentDoc = gql`
    fragment DealNode on DealNode {
  id
  agent {
    id
    email
    firstName
    lastName
  }
  currency
  creationTime
  updateTime
  car {
    id
    number
    color
    carSubModel {
      name
      localName
      carModel {
        name
        localName
      }
    }
  }
  carSubModel {
    id
    name
    localName
    carModel {
      id
      name
      localName
      brand {
        id
        name
      }
    }
  }
  proposal {
    id
    currency
    leaseDuration
    isOperational
    isLocked
  }
  modelYear
  freeKmPerYear
  monthlyPayment
  fullMonthlyPrice
  deposit
  carPrice
  servicePrice
  totalPrice
  baseIndex
  participationFee
  residualPrice
  comprehensiveInsurancePrice
  comprehensiveInsuranceYoungPrice
  compulsoryInsurancePrice
  licenceAndInsurancePricePerMonth
  licencePrice
  leaseDuration
  dealTypeString
  customer {
    id
    email
    name
    type
    title
    shouldUnionInvoices
  }
  notes
  isOperational
  status
  startDate
  endDate
  signDate
  proposalNumberRef
  trackingMonthlyRate
  npv
}
    `;